// Read one-time verifiers once, then remove them from the browser address/history.
// Query support is limited to older emailed links; new links use fragments so
// their token is never sent in an HTTP URL or Referer header.
export function readVerifierToken(location = window.location) {
  const fragment = new URLSearchParams(String(location.hash || "").replace(/^#/, ""));
  const query = new URLSearchParams(location.search || "");
  return String(fragment.get("token") || query.get("token") || "").trim();
}

export function clearVerifierFromUrl(location = window.location, history = window.history) {
  const fragment = new URLSearchParams(String(location.hash || "").replace(/^#/, ""));
  const query = new URLSearchParams(location.search || "");
  if (!fragment.has("token") && !query.has("token")) return;
  fragment.delete("token"); query.delete("token");
  const search = query.toString(), hash = fragment.toString();
  history.replaceState(history.state, "", `${location.pathname}${search ? `?${search}` : ""}${hash ? `#${hash}` : ""}`);
}
